import { Payment } from '@lendica/utils';
import { v2 } from '@lendica/api';

export const generateMockPayments = (total: number): Payment[] => {
    const now = new Date();
    const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
    const toYMD = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const products = ['paylater', 'drawdown', 'fundnow'];
    const dir = ['To Customer', 'From Customer'];
    const status = ['Scheduled', 'Cleared', 'In-Process'];
    const desc = ['005', '002', '111'];
    const list: Payment[] = Array.from({ length: total }).map((_, i) => {
        const dayOffset = i % 90;
        const d = new Date(now);
        // Even indices => future dates; Odd => past dates
        if (i % 2 === 0) d.setDate(now.getDate() + dayOffset);
        else d.setDate(now.getDate() - dayOffset);
        const p: any = {
            id: `mock-${i + 1}`,
            deal: `deal-${((i % 50) + 1).toString().padStart(8, '0')}`,
            event_date: toYMD(d),
            check_amount: Math.round(((i % 2000) + 100) * 100) / 100,
            description_code: desc[i % desc.length],
            payment_direction: dir[i % dir.length],
            payment_method: 'ACH',
            resulting_status: status[i % status.length],
            product_name: products[i % products.length],
        };
        return p as unknown as Payment;
    });
    return list;
};

export async function getMockPaginated(params: {
    page: number;
    pageSize: number;
    total: number;
    latencyMs?: number;
}): Promise<v2.PaginatedResponse<Payment>> {
    const { page, pageSize, total, latencyMs = 150 } = params;
    const all = generateMockPayments(total);
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    const slice = all.slice(start, end);
    const count = all.length;
    const hasMore = end < count;
    const resp: v2.PaginatedResponse<Payment> = {
        count,
        next: hasMore ? 'mock-next' : null,
        previous: page > 1 ? 'mock-prev' : null,
        results: slice,
    };
    await new Promise(r => setTimeout(r, latencyMs));
    return resp;
}
